export const classes = {
  wrapper: 'place-start',
  dueAt: 'tracking-wide font-medium text-xs text-grey-7 dark:text-mauve-2',
  resolved: 'text-grey-5 dark:text-mauve-3 line-through',
  today: 'text-orange-3 font-bold',
  tomorrow: 'text-purple-3 font-bold',
  past: 'text-pink-3 font-bold',
  icon: 'text-xl text-grey-6 dark:text-mauve-3 mr-1',
};
